import React, { Component } from 'react';
import { array } from 'prop-types';

import { Carousel } from '@snapask/common-components';

import { PrevArrow, NextArrow } from '@dragonfruit/components/Arrows';

import styles from './ScheduleSlideShow.scss';

const cx = require('classnames/bind').bind(styles);

class ScheduleSlideShow extends Component {
  static propTypes = {
    data: array.isRequired,
  };

  state = {
    activeIndex: 0,
  };

  componentDidMount() {
    this.calculateOffest(0);
  }

  onClickPill = index => {
    if (this.state.activeIndex === index) {
      return;
    }

    this.setState({
      activeIndex: index,
    });

    this.sliderWrapper.slider.slickGoTo(index);

    this.calculateOffest(index);
  };

  onChangeSlide = activeIndex => {
    this.setState({
      activeIndex,
    });

    this.calculateOffest(activeIndex);
  };

  calculateOffest = index => {
    const distanceFromLeft = (window.innerWidth - 190) / 2;
    const paddingOffset = index * 8;
    const left = (190 * index + paddingOffset - distanceFromLeft) * -1;
    this.setState({
      left,
    });
  };

  renderPill = (period, index) => (
    <div
      className={cx('pill', {
        active: this.state.activeIndex === index,
      })}
      key={index}
      onClick={() => this.onClickPill(index)}
    >
      {period.tabTitle}
      <span className={styles.time}>{period.tabTime}</span>
    </div>
  );

  renderSlideShow = (period, index) => (
    <div className={styles.slide} key={index}>
      <h4>{period.slideShowTitle}</h4>
      <p>{period.slideShowDesc}</p>
    </div>
  );

  render() {
    const { data } = this.props;
    const { activeIndex, left } = this.state;

    return (
      <div className={styles.root}>
        <div className={styles.pillsContainer}>
          <div
            className={styles.desktopPills}
            style={{
              left,
            }}
          >
            {data.map(this.renderPill)}
          </div>
        </div>
        <div className={styles.slideShow}>
          <Carousel
            ref={slider => {
              this.sliderWrapper = slider;
            }}
            settings={{
              dots: false,
              className: styles.sliderContainer,
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: activeIndex,
              centerMode: true,
              afterChange: this.onChangeSlide,
              nextArrow: <NextArrow />,
              prevArrow: <PrevArrow />,
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    arrows: false,
                    dots: true,
                  },
                },
              ],
            }}
          >
            {data.map(this.renderSlideShow)}
          </Carousel>
        </div>
      </div>
    );
  }
}

export default ScheduleSlideShow;



// WEBPACK FOOTER //
// ./app/containers/Mission/components/ScheduleSlideShow/ScheduleSlideShow.jsx